import PropTypes from "prop-types"
import classnames from "classnames"
import { percentageFormatter } from "helpers/formatters/numbers"
import { colorWithOpacity, darken } from "helpers/colors"

function GroupRow({ data, label, column: { color, noData, isUnmodeled }, index, value: groupValue, chartWidth, description }) {
  let loading = !data[index] && !noData && !isUnmodeled
  let value = !loading && !noData && !isUnmodeled && groupValue
  if (value === "Loading...") {
    loading = true
    value = ""
  }

  const style = loading
    ? { background: `linear-gradient(90deg, ${colorWithOpacity(color, 0.1)}, ${colorWithOpacity(color, 0.3)})` }
    : { background: "none" }

  return <div className={classnames({ loading })} style={style}>
    <div className="content-wrapper" title={description}>
      <div className="chart-bar" style={{ background: darken(color, 0.7), width: chartWidth }} />
      <div className="value-wrapper">
        <div className="label">{label}</div>
        <div className="value">{percentageFormatter(value / 100)}</div>
      </div>
    </div>
  </div>
}

GroupRow.propTypes = {
  column: PropTypes.shape({
    id: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    noData: PropTypes.bool,
    isUnmodeled: PropTypes.bool,
  }).isRequired,
  value: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  selector: PropTypes.func,
  data: PropTypes.array.isRequired,
  chartWidth: PropTypes.string.isRequired,
  description: PropTypes.string,
}

export default GroupRow
